import React from "react";

const VisibleContent = ({ visible, children }) => {
	if (!visible) return
	return children
}

export default React.memo(VisibleContent)
